const getters = {
  site: state => state.app.site,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  user: state => state.user,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  corpCode: state => state.user.code,
  roles: state => state.user.roles,
  intro: state => state.user.intro,
  uuid: state => state.user.uuid,
  user_id: state => state.user.user_id,
  permission_routes: state => state.permission.routes,
  route_id: state => state.permission.routerId,
  loginCaptcha: state => state.settings.loginCaptcha,
  errorLogs: state => state.errorLog.logs,
  secureSettings: state => state.settings.secureSettings,
  basicSettings: state => state.settings.basicSettings,
  systemTitle: state => state.settings.basicSettings ? state.settings.basicSettings.site_name : state.settings.systemTitle,
  systemLogo: state => state.settings.basicSettings ? state.settings.basicSettings.site_logo : state.settings.systemLogo,
  gisSettings: state => state.settings.gisSettings,
  theme: state => state.settings.theme,
  sidebarView: state => state.settings.sidebarView,
  workflowUserIds: state => state.workFlow.userIds,
  showSettings: state => state.settings.showSettings,
  tenant: state => state.tenant
}
export default getters
